import { ApolloClient, InMemoryCache, createHttpLink, from } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { FINANCIALS_FILTER_QUERY } from "graphql/financialsFilter";

const getBearerToken = () => {
  try {
    return localStorage.getItem("accessToken") || "";
  } catch {
    return "";
  }
};

let financialsFilterClient = null;

const getFinancialsFilterClient = () => {
  if (financialsFilterClient) {
    return financialsFilterClient;
  }

  const httpLink = createHttpLink({
    uri: process.env.REACT_APP_DOORSHARP_GRAPHQL_ENDPOINT,
  });

  const authLink = setContext((_, { headers }) => ({
    headers: {
      ...headers,
      "Content-Type": "application/json",
      ...(getBearerToken() ? { Authorization: `Bearer ${getBearerToken()}` } : {}),
    },
  }));

  financialsFilterClient = new ApolloClient({
    link: from([authLink, httpLink]),
    cache: new InMemoryCache(),
    defaultOptions: {
      query: {
        fetchPolicy: "network-only",
        errorPolicy: "all",
      },
    },
  });

  return financialsFilterClient;
};

export async function fetchFinancialsFilter() {
  try {
    const client = getFinancialsFilterClient();

    const { data } = await client.query({
      query: FINANCIALS_FILTER_QUERY,
      fetchPolicy: "network-only",
    });

    console.log("Financials Filter GraphQL response:", data);
    return data;
  } catch (error) {
    console.error("Financials Filter GraphQL error:", error);
    throw error;
  }
}

